(() => {
  const bind = () => {
    const header = document.querySelector('[data-kpro-header]');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = 'true';
    const toggle = header.querySelector('[data-kpro-toggle]');
    const panel = header.querySelector('[data-kpro-mobile]');
    const main = document.querySelector('main');
    const footer = document.querySelector('[data-kpro-footer]');
    const menu = header.querySelector('[data-kpro-services]');
    const close = (restore = false) => {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('kpro-nav-open');
      if (main) main.inert = false;
      if (footer) footer.inert = false;
      if (restore) toggle.focus();
    };
    toggle.addEventListener('click', () => {
      if (!panel.hidden) return close(true);
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('kpro-nav-open');
      if (main) main.inert = true;
      if (footer) footer.inert = true;
      panel.querySelector('summary, a')?.focus();
    });
    panel.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close()));
    document.addEventListener('click', event => {
      if (menu?.open && !menu.contains(event.target)) menu.open = false;
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        if (!panel.hidden) close(true);
        if (menu?.open) { menu.open = false; menu.querySelector('summary').focus(); }
      }
      if (event.key !== 'Tab' || panel.hidden) return;
      const elements = [toggle, ...panel.querySelectorAll('a, summary')].filter(el => el.getClientRects().length);
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    const breakpoint = window.matchMedia('(min-width: 1061px)');
    breakpoint.addEventListener('change', event => { if (event.matches) close(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();

// Accept sizing and privacy-safe funnel messages only from configured Directory iframes.
(() => {
  const directoryOrigin = 'https://directory.christmascontractor.com';
  window.addEventListener('message', event => {
    if (event.origin !== directoryOrigin) return;
    const data = event.data;
    if (!data || typeof data !== 'object' || data.version !== 1) return;

    const matchingFrames = (selector, dataKey, pathPrefix) => {
      const matches = [];
      document.querySelectorAll(selector).forEach(frame => {
        if (!frame.contentWindow || event.source !== frame.contentWindow) return;
        const listing = frame.dataset[dataKey];
        if (!listing) return;
        let source;
        try { source = new URL(frame.src); } catch { return; }
        if (source.origin !== directoryOrigin || !(Array.isArray(pathPrefix) ? pathPrefix : [pathPrefix]).some(prefix => source.pathname === prefix + encodeURIComponent(listing))) return;
        matches.push({ frame, listing });
      });
      return matches;
    };

    if (data.type === 'cc-estimate-embed-height') {
      if (typeof data.height !== 'number' || !Number.isFinite(data.height) || data.height < 320 || data.height > 16000) return;
      matchingFrames('iframe[data-kos-directory-estimate]', 'kosDirectoryEstimate', '/estimate/embed/').forEach(({ frame }) => {
        frame.style.height = Math.ceil(data.height) + 'px';
      });
      return;
    }

    if (data.type === 'cc-estimate-embed-event') {
      const allowedEvents = new Set(['form_start', 'submit_attempt', 'submitted']);
      const allowedCustody = new Set(['organization_routed', 'platform_pending_claim']);
      if (!allowedEvents.has(data.event)) return;
      if (data.event === 'submitted' && !allowedCustody.has(data.custody)) return;
      const matches = matchingFrames('iframe[data-kos-directory-estimate]', 'kosDirectoryEstimate', '/estimate/embed/');
      if (matches.length !== 1) return;
      window.dispatchEvent(new CustomEvent('kingdom-os:estimate-event', {
        detail: {
          event: data.event,
          ...(data.event === 'submitted' ? { custody: data.custody } : {})
        }
      }));
      return;
    }

    if (data.type === 'cc-design-studio-embed-event') {
      if (data.event !== 'submit_attempt' && data.event !== 'submitted') return;
      if (data.event === 'submitted' && (
        typeof data.designAttached !== 'boolean' ||
        typeof data.renderedImageAttached !== 'boolean' ||
        (data.renderedImageAttached && !data.designAttached)
      )) return;
      const matches = [];
      document.querySelectorAll('iframe[data-kos-directory-studio]').forEach(frame => {
        if (!frame.contentWindow || event.source !== frame.contentWindow) return;
        let source;
        try { source = new URL(frame.src); } catch { return; }
        if (source.origin !== directoryOrigin || !/^\/design-studio\/embed\/[^/]+\/?$/.test(source.pathname)) return;
        matches.push(frame);
      });
      if (matches.length !== 1) return;
      window.dispatchEvent(new CustomEvent('kingdom-os:studio-event', {
        detail: {
          event: data.event,
          ...(data.event === 'submitted' ? {
            designAttached: data.designAttached,
            renderedImageAttached: data.renderedImageAttached
          } : {})
        }
      }));
      return;
    }

    const isLegacy = data.type === 'kcl-careers-embed-height';
    if (!isLegacy && data.type !== 'cc-hiring-embed-height') return;
    if (typeof data.height !== 'number' || !Number.isFinite(data.height) || data.height < 320 || data.height > 16000) return;
    matchingFrames('iframe[data-kos-directory-hiring]', 'kosDirectoryHiring', ['/jobs/openings/embed/company/', '/jobs/openings/embed/']).forEach(({ frame, listing }) => {
      const currentKingdomMessage = isLegacy && listing === 'kingdom-christmas-lights' && data.listingSlug === undefined;
      if (!currentKingdomMessage && data.listingSlug !== listing) return;
      frame.style.height = Math.ceil(data.height) + 'px';
    });
  });
})();
